import AdminSettings from "../models/AdminSettings";
import Collection from "../models/CollectionModel";
import Services from "../models/ServiceModel";
import WhatsApp from "../models/WhatsappModel";
import request from "../shared/http";
import appConfig from "../shared/js/app-config";
import { removeWhiteSpace } from "../shared/utils/extensions";
const cache = {};
class ServicesService {
    collection = new Collection(Services);
    parse(item) {
        return {
          id: item.id,
          name: item.name,
          businessType: item.business_type,
          address: item.address,
          email: item.email,
          mobile: item.mobile,
          country: item.country,
          imageUpdatedAt: item.image_updated_at,
          addressLine1: item.address_line_1,
          addressLine2: item.address_line_2,
          city: item.city,
          state: item.state,
          pincode: item.pincode,
          customerCareEmail: item.customer_care_email,
          customerCareMobile: item.customer_care_mobile,
          faviconUrl: item.favicon_url,
        };
      }
      serialize(model) {
        return {
          id: model.getId(),
          name: model.getName(),
          business_type: model.getBusinessType(),
          address: model.getAddress(),
          email: model.getEmail(),
          mobile: model.getMobile(),
          country: model.getCountry(),
          portal_url: model.getPortalUrl(),
          image_updated_at: model.getImageUpdatedAt(),
          address_line_1: model.getAddressLine1(),
          address_line_2: model.getAddressLine2(),
          city: model.getCity(),
          state: model.getState(),
          pincode: model.getPincode(),
          customer_care_email: model.getCustomerCareEmail(),
          customer_care_mobile: model.getCustomerCareMobile(),
          favicon_url: model.getFaviconUrl(),
        };
      }
      WhatsappParse(item) {
        return {
          id: item.id,
          phoneNumberId: item.phoneNumberId,
          wabaId: item.wabaId,
          accessToken: item.accessToken,
          serviceId: item.serviceId,
          templateName: item.template_name,
          templateType: item.template_type,
          templateEvent: item.template_event,
          language: item.language,
          event: item.event,
          templateBody: item.template_body,
          templateFooter: item.template_footer,
          templateHeader: item.template_header,
          phoneNumber: item.phoneNumber,
          phoneText: item.phone_text,
          websiteText: item.website_text,
          websiteLink: item.website_link,
          isEnable: item.is_enable,
          status: item.status,
          catalogButtonText: item.catalog_button_text ?? '',
          catalogId: item.catalog_id,
          catalogName: item.catalog_name,
          createdAt: item.created_at,
          productId: item.product_id,
          variantId: item.variant_id,
          productCount: item.product_count,
          authText: item.auth_text,
          headerType: item.header_type,
          invoiceText: item.invoice_text,
          storeId: item.storeId || item.store_id,
          isEmbeddedSignup: item.isEmbeddedSignup,
          onboardingMode: item.onboardingMode || item.onboarding_mode,
          chunkData: item.chunkData,
          isHistorySync: item.isHistorySync,
          isContactSync: item.isContactSync,
        };
      }
      whatsappSerialize(model) {
        return {
          phone_number_id: model.getPhoneNumberId(),
          waba_id: model.getWabaId(),
          access_token: model.getAccessToken(),
          service_id: model.getServiceId(),
          is_enable: model.getIsEnable(),
          language: model.getLanguage(),
          phone_number: model.getPhoneNumber(),
          phone_text: model.getPhoneText(),
          template_body: model.getTemplateBody(),
          template_event: model.getTemplateEvent(),
          template_footer: model.getTemplateFooter(),
          template_header: model.getTemplateHeader(),
          template_name: model.getTemplateName(),
          template_type: model.getTemplateType(),
          website_link: model.getWebsiteLink(),
          website_text: model.getWebsiteText(),
          catalog_button_text: model.getCatalogButtonText(),
          auth_text: model.getAuthText(),
          header_type: model.getHeaderType(),
          invoice_text: model.getInvoiceText(),
          store_id: model.getStoreId(),
          is_embedded_signup: model.getIsEmbeddedSignup(),
          onboarding_mode: model.getOnboardingMode?.(),
          token: model.getToken(),
        };
      }
      async fetch() {
        if (!cache.service) {
          const response = await request.get(this.getURL());
          const { data } = response;
          cache.service = new Services({
            id: data.id,
            name: data.name,
            businessType: data.business_Type,
            country: data.country,
            email: data.email,
            mobile: data.mobile,
            imageUpdatedAt: data.image_updated_at,
            address: data.address,
          });
        }
        return cache.service;
      }

      async getOrganizationServices({ organizationId, offset = 0, limit = 5 }) {
        const url = `/organizations/${organizationId}/services`;
        const response = await request.get(url, { offset, limit });
        return response.data;
      }
      async getAppId() {
        const url = '/whatsapp/signup/appid';
        const { data } = await request.get(url);
        return data;
      }

      async createWhatsapp(model) {
        const url = `/whatsapp/create/${appConfig.getServiceId()}`;
        console.log('app', appConfig.getServiceId());
        
        const { data } = await request.post(url, {
          ...this.whatsappSerialize(model),
        });
        return data.id;
      }

      async createEmbeddedWhatsapp(model) {
        const url = `/whatsapp/embedded/${appConfig.getServiceId()}`;
        console.log('app', model);
        
        const { data } = await request.post(url, {
          ...this.whatsappSerialize(model),
        });
        return data;
      }

      async getWhatsapp() {
        const url = `/whatsapp/${appConfig.getServiceId()}`;
        const { data } = await request.get(url);
        console.log('data', data);
        
        if (data) {
        return new WhatsApp(this.WhatsappParse(data));
        }
        return null;
      }
      async getAccessTokenByExchangeToken(code, pinValue) {
        const url = `/whatsapp/token/${appConfig.getServiceId()}`;
        return request.get(url, {
          params: {
            token: code,
            pin: pinValue,
          },
        });
      }

      async creatCatalog(id) {
        const url = `/catalog/${appConfig.getServiceId()}`;
        const { data } = await request.put(url, { catalog_id: id });
        return data;
      }

      async getCatalog() {
        const url = `/catalog/${appConfig.getServiceId()}`;
        const { data } = await request.get(url);
        return data;
      }

      async getCatalogProducts(id) {
        const url = `/catalog/product/${appConfig.getServiceId()}`;
        const { data } = await request.get(url, {
          params: {
            id,
          }
        });
        return data;
      }

      async getVisualSearchSettings() {
        const url = `/catalog/${appConfig.getServiceId()}/visual-search`;
        const { data } = await request.get(url);
        return data?.data ?? data;
      }

      async updateVisualSearchSettings(payload) {
        const url = `/catalog/${appConfig.getServiceId()}/visual-search`;
        const { data } = await request.put(url, payload);
        return data?.data ?? data;
      }

      async buildVisualCatalogIndex() {
        const url = `/catalog/${appConfig.getServiceId()}/visual-index`;
        const { data } = await request.post(url);
        return data?.data ?? data;
      }

      async createService({
    organizationId, mobile, country, email, address,
  }) {
    const url = `/organizations/${organizationId}/service`;
    const response = await request.post(url, {
      mobile,
      country,
      email,
      address,
    });
    return response;
  }

  async getServiceById(serviceId) {
    if (!cache.service) {
      const { data } = await request.get(`/service/${serviceId}`);
      cache.service = new Services(this.parse(data));
    }
    return cache.service;
  }

  settingsParse(item) {
    return {
      id: item?.id || null,
      graceNewStore: item?.grace_new_store || null,
      expiryGrace: item?.expiry_grace || null,
      trialPeriod: item?.trial_period || null,
    };
  }

  async getAdminSettings() {
    const url = '/admin/settings/admin_123';
    const { data } = await request.get(url);
    return new AdminSettings(this.settingsParse(data));
  }

  parseSettings(item) {
    if (!item) {
      return {
        id: null,
        isBlueTickEnabled: false,
        isTypingIndicatorEnabled: false,
        isChatSimulationEnabled: false,
        allSettings: {},
      };
    }

    return {
      id: item.id || null,
      isBlueTickEnabled: Boolean(item.is_blue_tick_enabled),
      isTypingIndicatorEnabled: Boolean(item.is_typing_indicator_enabled),
      isChatSimulationEnabled: Boolean(item.is_chat_simulation_enabled),
      allSettings: item.all_settings || {},
    };
  }

  async getServiceSettings() {
    const serviceId = appConfig.getServiceId();
    const url = `/settings/${serviceId}`;
    const { data } = await request.get(url);
    return this.parseSettings(data);
  }

  async saveServiceSettings(settings) {
    const serviceId = appConfig.getServiceId();
    const url = `/settings/${serviceId}`;
    const payload = {
      id: settings.id,
      isBlueTickEnabled: settings.isBlueTickEnabled,
      isTypingIndicatorEnabled: settings.isTypingIndicatorEnabled,
      isChatSimulationEnabled: settings.isChatSimulationEnabled,
      allSettings: settings.allSettings || null,
    };
    const { data } = await request.put(url, payload);
    return this.parseSettings(data);
  }

  async syncHistory(type) {
    const serviceId = appConfig.getServiceId();
    console.log('serviceId', serviceId);
    
    const url = `/sync/history/${serviceId}`;
    const { data } = await request.post(url, {
      type,
    });
    return data;
  }

  async getAiProviderConfigs() {
    const serviceId = appConfig.getServiceId();
    const { data } = await request.get(`/ai/providers/${serviceId}`);
    return Array.isArray(data) ? data : [];
  }

  async upsertAiProviderConfig(payload) {
    const serviceId = appConfig.getServiceId();
    const { data } = await request.put(`/ai/providers/${serviceId}`, payload);
    return data;
  }

  async deleteAiProviderConfig(providerKey, configName = "default") {
    const serviceId = appConfig.getServiceId();
    const encodedProvider = encodeURIComponent(providerKey);
    const encodedConfigName = encodeURIComponent(configName);
    const { data } = await request.delete(`/ai/providers/${serviceId}/${encodedProvider}?config_name=${encodedConfigName}`);
    return data;
  }

  async getAiPersonas() {
    const serviceId = appConfig.getServiceId();
    const { data } = await request.get(`/ai/personas/${serviceId}`);
    return Array.isArray(data) ? data : [];
  }

  async createAiPersona(payload) {
    const serviceId = appConfig.getServiceId();
    const { data } = await request.post(`/ai/personas/${serviceId}`, payload);
    return data;
  }

  async updateAiPersona(id, payload) {
    const serviceId = appConfig.getServiceId();
    const { data } = await request.put(`/ai/personas/${serviceId}/${id}`, payload);
    return data;
  }

  async deleteAiPersona(id) {
    const serviceId = appConfig.getServiceId();
    const { data } = await request.delete(`/ai/personas/${serviceId}/${id}`);
    return data;
  }

  async getAiUsageSummary(days = 14) {
    const serviceId = appConfig.getServiceId();
    const { data } = await request.get(`/ai/usage/${serviceId}?days=${encodeURIComponent(days)}`);
    return data || { timeline: [], totals: {} };
  }

  async getCallingSettings() {
  try {
    const response = await request.get(`/whatsapp/calling-settings/${appConfig.getServiceId()}`);
    return response.data;
  } catch (error) {
    console.error('Failed to get calling settings:', error);
    return { available: false, enabled: false };
  }
}

async enableCalling(settings = {}) {
  const response = await request.post(`/whatsapp/enable-calling/${appConfig.getServiceId()}`, settings);
  return response.data;
}

async disableCalling() {
  const response = await request.post(`/whatsapp/disable-calling/${appConfig.getServiceId()}`);
  return response.data;
}

async updateCallHours(callHours) {
  const response = await request.post(`/whatsapp/update-call-hours/${appConfig.getServiceId()}`, {
    call_hours: callHours
  });
  return response.data;
}
    
}
export default new ServicesService();